import { AssessmentTestContextType } from '..';
import { closeOpenStepIntervals, queueForSync } from '../helpers';

export type GoToPreviousStepActionType = {
  type: 'GO_TO_PREVIOUS_STEP';
  timestamp: Date;
};

export function goToPreviousStepReducer(
  state: AssessmentTestContextType,
  action: GoToPreviousStepActionType
): AssessmentTestContextType {
  if (state.screen.type !== 'STEP') {
    throw new Error(
      'GO_TO_PREVIOUS_STEP can only be called when in step screen'
    );
  }
  const previousStepIndex = state.screen.stepIndex - 1;
  if (previousStepIndex < 0) {
    throw new Error(
      'GO_TO_PREVIOUS_STEP can only be called when not on the first step'
    );
  }
  const currentStep = state.steps[state.screen.stepIndex];
  const previousStep = state.steps[previousStepIndex];
  return {
    ...state,
    ...queueForSync(state),
    steps: state.steps.map((s) =>
      s.id === currentStep.id
        ? closeOpenStepIntervals({ step: s, timestamp: action.timestamp })
        : s
    ),
    screen: {
      type: 'STEP',
      stepId: previousStep.id,
      sectionId: null,
      stepIndex: previousStepIndex,
    },
  };
}
